import { UserIdentityInterface, userIdentityVar } from '../models/UserIdentity'

export const updateUserIdentityFn = (
  updatedUserIdentity: UserIdentityInterface | undefined
): UserIdentityInterface | undefined => {
  const identity = updatedUserIdentity ? { ...updatedUserIdentity } : undefined
  return userIdentityVar(identity)
}
